import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { ProfileEntity } from '../profile/profile.entity';
import { FeedBackResponseModel } from './dto/feedback-response-module';
import { FeedbackDTO } from './dto/feedback.dto';
import { FeedBackEntity } from './feedback.entity';

@Injectable()
export class FeedbackService {    
    constructor(
        @InjectRepository(FeedBackEntity)
        private feedbackRepository: Repository<FeedBackEntity>,
        @InjectRepository(ProfileEntity)
        private profileRepo: Repository<ProfileEntity>,
        
    ) {}

    
    async createFeedback(queryParams, feedDto:FeedbackDTO, request:Request):Promise<FeedBackResponseModel> {
        const response = new FeedBackResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saveEvent = await this.feedbackRepository.save(feedDto);
                if(saveEvent) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Feedback sent  successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Feedback failed to sent')
                }
            } else {
                const saveEvent = await this.feedbackRepository.save(feedDto);
                if(saveEvent) {
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Feedback sent  successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Feedback failed to sent')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    
   
}
